export enum SettingsNavigationKeys {
  AccountSettings = '',
  SecuritySettings = 'security',
  TeamMembers = 'team',
  Billing = 'billing',
  Notifications = 'notifications',
}
